import { UserGroup } from '@/types/user'

export const isUserGroup = (source: unknown): source is UserGroup => {
  return typeof source === 'string' && ['ad', 'kol'].includes(source)
}
